<script>
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import { useDonationsPublicStore } from '@/stores/donationPublic.js'
import TwCard from '@/components/generic/tw-card.vue'
import TwListGroup from '@/components/generic/list-group/tw-list-group.vue'
import DonationListGroupItemB from '@/components/donations/public/donation-list-group-item-b.vue'
import TwSelectDropdown from '@/components/generic/tw-select-dropdown.vue'
import fetchItemsMixin from '@/mixins/fetchItemsMixin.js'
import TwPaginator from '@/components/generic/tw-paginator.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { HeartIcon } from '@heroicons/vue/24/outline'
export default {
  name: 'DonationsListGroup',
  components: { TwButton, TwSelectDropdown, DonationListGroupItemB, TwListGroup, TwLoadingSpinner },
  mixins: [fetchItemsMixin],
  props: {
    fundraiserPage: {
      type: Object,
      default: null,
    },
    fundraiser: {
      type: Object,
      default: null,
    },
    team: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      SortBy: 'created_at-desc'
    }
  },
  computed: {
    itemsStoreModule () {
      return useDonationsPublicStore()
    },
    filters() {
      return {
        ...(this.fundraiserPage ? { fundraiser_page_id: this.fundraiserPage.id } : {}),
        ...(this.fundraiser ? { fundraiser_id: this.fundraiser.id } : {}),
        ...(this.team ? { team_id: this.team.id } : {})
      }
    },
    sortByOptions() {
      return [
        { label: 'Latest', value: 'created_at-desc' },
        { label: 'Oldest', value: 'created_at-asc' },
        { label: 'Amount: high to low', value: 'amount-desc' },
        { label: 'Amount: low to high', value: 'amount-asc' }
      ]
    }
  },
  watch: {
    SortBy(newVal) {
      if(newVal !== null) {
        const split = newVal.split('-')
        useDonationsPublicStore().orderBy = split[0]
        useDonationsPublicStore().orderDirection = split[1]
      }
      this.fetchItems()
    }
  },
  mounted() {
    const split = this.SortBy.split('-')
    useDonationsPublicStore().orderBy = split[0]
    useDonationsPublicStore().orderDirection = split[1]
    this.fetchItems()
  },
  methods: {
  }
}
</script>

<template>
  <div>
    <div v-if="total > 1">
    <div class="flex flex-wrap gap-2 justify-between items-center whitespace-nowrap">
      <h6 class="text-base flex gap-2 items-center">
       <span>{{ total }}</span>Donations 
      </h6>
      <tw-select-dropdown v-model="SortBy" :options="sortByOptions" label-key="label" value-key="value">
        Sort
      </tw-select-dropdown>
    </div>
    </div>
    <div class="clear-both" />
    <tw-loading-spinner v-if="LoadingFetchingItems" />
    <tw-list-group v-else-if="!LoadingFetchingItems && items.length > 0">
      <donation-list-group-item-b v-for="donation in items" :key="'fundraiser-supporter-key-' + donation.id" :donation="donation" size="sm" class="mt-2" />
    </tw-list-group>
    <p v-else class="mb-2 flex gap-2 items-center justify-center text-center bg-amber-50 rounded-lg p-3 flex-wrap text-sm">
      <i class="pi pi-heart text-amber-600" />
      Make a donation to become the first supporter
    </p>
    <!--<tw-paginator v-if="total > perPage" :total="total" :per-page="perPage" size="sm" @page-change="fetchItems" />-->
    <tw-button v-if="page < lastPage" variant="outline" size="sm" class="flex w-full justify-center mt-2" @click="fetchNextItems">
      Show more donors
    </tw-button>
  </div>
</template>

<style scoped>

</style>
